import React from 'react';
import { Col, Row } from 'reactstrap';
import styles from './AboutUs.module.scss';
import { Animated } from 'react-animated-css';

const AboutUs = () => {
  return (
    <div className={styles.main_about} id="aboutus">
      <Row>
        <Col sm={12} md={8}>
          <Animated
            isVisible={true}
            animationIn='animate__fadeInUpBig'
            animationOut='animate__fadeInUpBig'
          >
            <div className={styles.about_content}>
              <div>
                <h1>
                  ABOUT <span>US</span>
                </h1>
                <p>
                  The Mutant Ape Base Club is a virtual community built around the concept of Mutant Ape Base Club NFTs, 
                  which are unique digital assets residing on Base blockchain. The platform aims to create an interactive 
                  and rewarding ecosystem where members can participate in governance decisions and earn rewards based on their contributions.
                </p>
              </div>
              <div>
                <br/><br/>
                <h2>Governance Structure</h2>
                <p>
                  The Mutant Ape Base Club is governed by its community members through a decentralized governance model. 
                  Each Mutant Ape Base Club NFT holder has the right to participate in decision-making processes, including voting on proposals and electing representatives. 
                  The governance structure ensures that the platform's evolution aligns with the interests of its stakeholders.
                </p>
              </div>
              <div>
                <br/><br/>
                <h2>Community Engagement</h2>
                <p>
                   The Mutant Ape Base Club encourages active participation and engagement 
                   from its community members. In addition to the stake and earn mechanism, 
                   the platform hosts various community activities, such as contests, events, 
                   and discussions, which offer additional opportunities for members to earn 
                   rewards and contribute to the platform's growth.
                </p>
              </div>
            </div>
          </Animated>
        </Col>
        <Col sm={12} md={4}>
          <Animated
            animationIn='animate__backInUp'
            animationOut='animate__backInUp'
            isVisible={true}
          >
            <div className={styles.sideBear}>
              <img src='Assets/kay2.png' alt='sidebear' />
            </div>
          </Animated>
        </Col>
      </Row>
    </div>
  );
};

export default AboutUs;
